import api from "../../index"

const wealthPartnerAuthApi = api.injectEndpoints({
  endpoints: (build) => ({
    wealthPartnerLogin: build.mutation({
      query: (params) => ({
        url: `/wealthPartner/auth/login`,
        method: "POST",
        body: params,
      }),
    }),
    wealthPartnerVerifyLoginOTP: build.mutation({
      query: (params) => ({
        url: `/wealthPartner/auth/verify/otp`,
        method: "POST",
        body: params,
      }),
    }),
    wealthPartnerResendOTP: build.mutation({
      query: (params) => ({
        url: `/wealthPartner/auth/resend/otp`,
        method: "POST",
        body: params,
      }),
    }),
    wealthPartnerForgotPassword: build.mutation({
      query: (params) => ({
        url: `/wealthPartner/auth/forgot-password`,
        method: "POST",
        body: params,
      }),
    }),
    wealthPartnerResetPassword: build.mutation({
      query: (params) => ({
        url: `/wealthPartner/auth/reset-password`,
        method: "POST",
        body: params,
      }),
    }),
    wealthPartnerUpdatePassword: build.mutation({
      query: (params) => ({
        url: `/profile/wealth-partner/change-password`,
        method: "PUT",
        body: params,
      }),
    }),
    getWealthPartnerProfile: build.query({
      query: () => ({
        url: `/profile/wealth-partner/profile`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useWealthPartnerLoginMutation,
  useWealthPartnerVerifyLoginOTPMutation,
  useWealthPartnerResendOTPMutation,
  useWealthPartnerForgotPasswordMutation,
  useWealthPartnerResetPasswordMutation,
  useWealthPartnerUpdatePasswordMutation,
  useLazyGetWealthPartnerProfileQuery,
} = wealthPartnerAuthApi
